import PropTypes from "prop-types";
import * as React from "react";
import { Typography } from "../../themeV2";
import css from "./ShopInfo.module.css";
import { statRowShape } from "./tones";

const TONE_CLASS = {
  critical: css.toneCritical,
  warning: css.toneWarning,
};

/*
 * Three steps of hierarchy per row: the value reads largest and darkest, the
 * label sits a step down in size and colour, the hint a step below that.
 */
export default function StatList({ rows }) {
  return (
    <dl className={css.statList}>
      {rows.map(({ label, value, hint, tone }) => (
        <div className={css.statRow} key={label}>
          <Typography
            variant="label-lg"
            as="dt"
            color="variant"
            className={css.statTerm}
          >
            {label}
          </Typography>
          <dd className={css.statDetail}>
            <Typography
              variant="title-md"
              as="span"
              className={[css.statValue, TONE_CLASS[tone]]
                .filter(Boolean)
                .join(" ")}
            >
              {value}
            </Typography>
            {hint ? (
              <Typography
                variant="label-md"
                as="span"
                color="variant"
                className={css.statHint}
              >
                {hint}
              </Typography>
            ) : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}

StatList.propTypes = {
  rows: PropTypes.arrayOf(statRowShape).isRequired,
};
